export const mutations = {
  userInformationLoaded(state, { userInformation }) {
    state.userInformation = {
      awards: userInformation.expands[0].data,
      userData: userInformation.data,
      isLoaded: true,
    };
  },
};
